'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _getTabName = require('./getTabName');

var _getTabName2 = _interopRequireDefault(_getTabName);

var _selectors = require('./selectors');

var _modules = require('shared/modules');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PageFooter(_ref) {
  var containerClass = _ref.containerClass,
      modules = _ref.modules,
      route = _ref.route,
      active = _ref.active,
      selectTab = _ref.selectTab;

  return _react2.default.createElement(
    'div',
    { className: containerClass + ' tabs' },
    _react2.default.createElement(
      'ul',
      { className: 'tab-list' },
      modules.map(function (_ref2, key) {
        var tab = _ref2.tab,
            altTab = _ref2.altTab,
            type = _ref2.type;
        return _react2.default.createElement(
          'li',
          { className: active === key ? 'selected' : null,
            key: key
          },
          _react2.default.createElement(
            'a',
            {
              className: active === key ? 'selected' : null,
              onClick: function onClick() {
                selectTab(key);
              }
            },
            _react2.default.createElement(
              'div',
              { className: 'desktop-only' },
              (0, _getTabName2.default)({
                tab: tab,
                type: type
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'mobile-only' },
              (0, _getTabName2.default)({
                tab: altTab,
                type: type
              })
            )
          )
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'tab-container ' + containerClass + '-content ' + modules[active].type },
      modules.slice(active, active + 1).map(function (module) {
        return _react2.default.createElement(_modules.Module, (0, _extends3.default)({
          key: active,
          route: route
        }, module));
      })
    )
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(PageFooter);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/PageFooter/PageFooter.jsx
// module id = 1108
// module chunks = 0